module.exports = __webpack_public_path__ + "img/default-bank-icon.1400e80b.svg";